import React from 'react';
import { ButtonGroup, IconButton, Tooltip } from '@mui/material';
import {
  NavigateBefore as PrevIcon,
  NavigateNext as NextIcon,
  FirstPage as FirstIcon,
  LastPage as LastIcon
} from '@mui/icons-material';

interface NavigationButtonsProps {
  onNavigate: (direction: 'first' | 'prev' | 'next' | 'last') => void;
  isFirst: boolean;
  isLast: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onNavigate,
  isFirst,
  isLast
}) => {
  return (
    <ButtonGroup size="small" aria-label="student navigation">
      <Tooltip title="First Student">
        <span>
          <IconButton
            onClick={() => onNavigate('first')}
            disabled={isFirst}
            size="small"
          >
            <FirstIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Previous Student">
        <span>
          <IconButton
            onClick={() => onNavigate('prev')}
            disabled={isFirst}
            size="small"
          >
            <PrevIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Next Student">
        <span>
          <IconButton
            onClick={() => onNavigate('next')}
            disabled={isLast}
            size="small"
          >
            <NextIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Last Student">
        <span>
          <IconButton
            onClick={() => onNavigate('last')}
            disabled={isLast}
            size="small"
          >
            <LastIcon />
          </IconButton>
        </span>
      </Tooltip>
    </ButtonGroup>
  );
};